import { makeStyles } from '@material-ui/core';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      '&$hasSubtitle': {
        alignItems: 'flex-start',
      },
    },
    hasSubtitle: {},

    subtitle: {
      color: COLORS.neutral.lightGray,
      marginTop: theme.spacing(0.375),
      fontSize: theme.typography.pxToRem(10),
      lineHeight: theme.typography.pxToRem(12),
    },
  }),
  {
    name: 'SidebarLink',
  }
);
